var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobTitleFormIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 3.1H9.8V1.15C9.8 0.7912 9.4871 0.5 9.1 0.5H4.9C4.5136 0.5 4.2 0.7912 4.2 1.15V3.1H0.7C0.3136 3.1 0 3.3912 0 3.75V7C0 7.3588 0.3136 7.65 0.7 7.65V12.2C0.7 12.9169 1.3279 13.5 2.1 13.5H11.9C12.6728 13.5 13.3 12.9169 13.3 12.2V7.65C13.6871 7.65 14 7.3588 14 7V3.75C14 3.3912 13.6871 3.1 13.3 3.1ZM5.6 1.8H8.4V3.1H5.6V1.8ZM1.4 4.4H12.6V6.35H9.1V5.7C9.1 5.3412 8.7871 5.05 8.4 5.05H5.6C5.2136 5.05 4.9 5.3412 4.9 5.7V6.35H1.4V4.4ZM7.7 6.35V7.65H6.3V6.35H7.7ZM11.9 12.2H2.1V7.65H4.9V8.3C4.9 8.6588 5.2136 8.95 5.6 8.95H8.4C8.7871 8.95 9.1 8.6588 9.1 8.3V7.65H11.9V12.2Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobTitleFormIcon);
export default __webpack_public_path__ + "static/media/JobTitleFormIcon.5c6a6fc65e461827eec12139f51b7e93.svg";
export { ForwardRef as ReactComponent };